import { render, staticRenderFns } from "./objectTypeEdit.vue?vue&type=template&id=82d2654a"
import script from "./objectTypeEdit.vue?vue&type=script&lang=js"
export * from "./objectTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82d2654a')) {
      api.createRecord('82d2654a', component.options)
    } else {
      api.reload('82d2654a', component.options)
    }
    module.hot.accept("./objectTypeEdit.vue?vue&type=template&id=82d2654a", function () {
      api.rerender('82d2654a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/object/objectType/objectTypeEdit.vue"
export default component.exports